/* eslint-disable react/no-multi-comp */
import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import { matchPath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { List, Typography } from '@mui/material';

import { NavigationListItem } from './components';
import useRouter from 'utils/useRouter';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
  },
}));

const NavigationList = ({ pages, isFullNav, ...rest }) => {
  const { t } = useTranslation();

  return (
    <List>
      {pages.reduce(
        (items, page) =>
          reduceChildRoutes({ items, page, t, isFullNav, ...rest }),
        [],
      )}
    </List>
  );
};

NavigationList.propTypes = {
  depth: PropTypes.number,
  pages: PropTypes.array,
  isFullNav: PropTypes.bool,
};

const reduceChildRoutes = ({ router, items, page, depth, t, isFullNav }) => {
  if (page.children) {
    const open = matchPath(router.location.pathname, {
      path: page.href,
      exact: false,
    });

    items.push(
      <NavigationListItem
        depth={depth}
        icon={page.icon}
        key={page.title}
        label={page.label}
        open={Boolean(open)}
        title={t(page.title)}
        isFullNav={isFullNav}>
        <NavigationList
          depth={depth + 1}
          pages={page.children}
          router={router}
          isFullNav={isFullNav}
        />
      </NavigationListItem>,
    );
  } else {
    items.push(
      <NavigationListItem
        depth={depth}
        href={page.href}
        icon={page.icon}
        key={page.title}
        label={page.label}
        title={t(page.title)}
        isFullNav={isFullNav}
      />,
    );
  }

  return items;
};

const Navigation = ({
  title,
  pages,
  className,
  isFullNav,
  component: Component,
  ...rest
}) => {
  const classes = useStyles();
  const router = useRouter();

  return (
    <Component {...rest} className={clsx(classes.root, className)}>
      {title && <Typography variant="overline">{title}</Typography>}
      <NavigationList
        depth={0}
        pages={pages}
        router={router}
        isFullNav={isFullNav}
      />
    </Component>
  );
};

Navigation.defaultProps = {
  component: 'nav',
};

Navigation.propTypes = {
  title: PropTypes.string,
  component: PropTypes.any,
  isFullNav: PropTypes.bool,
  className: PropTypes.string,
  pages: PropTypes.array.isRequired,
};

export default Navigation;
